import { AMRAP_FLOOR_SHOWN_MAX, amrapStopRirOf } from '@heraion/shared';

import type { DraftSet } from './state/loggerDraftTypes';

// #539: what the AMRAP chip (the INTENTION, `DraftSet.amrap`) changes on the
// panel. Two readers each: the effort band's target ring and the reps badge.

/** The effort target ring, as canonical rir. Chip on: the program's stop
 *  rule (N, or 0 for "form breaks"), else 0. Chip off: `rirPrescribed`. On an
 *  AMRAP set the AMRAP wins over a prescribed RIR. */
export const effortTargetOf = (
  set: Pick<DraftSet, 'amrap' | 'amrapPrescribed' | 'amrapStopPrescribed' | 'rirPrescribed'>,
): number | null => {
  if (set.amrap) {
    return (
      amrapStopRirOf({
        amrap: set.amrapPrescribed,
        ...(set.amrapStopPrescribed ? { amrapStop: set.amrapStopPrescribed } : {}),
      }) ?? 0
    );
  }
  return set.rirPrescribed ?? null;
};

/** Does the reps cell carry an AMRAP badge: the plan asked for one, or the
 *  chip proposed a test on this set. */
export const hasAmrapFloor = (
  set: Pick<DraftSet, 'amrapPrescribed' | 'amrapTest'>,
): boolean => set.amrapPrescribed || set.amrapTest !== undefined;

/** The rep minimum to show, or null. The plan's floor or the proposed
 *  test's, only from 1 to AMRAP_FLOOR_SHOWN_MAX: past it the badge reads
 *  "AMRAP" alone. */
export const amrapFloorShown = (
  set: Pick<DraftSet, 'amrapPrescribed' | 'amrapFloor' | 'amrapTest'>,
): string | null => {
  const raw = set.amrapPrescribed ? set.amrapFloor : set.amrapTest?.floor;
  const n = raw === undefined ? NaN : Number(raw.trim());
  return Number.isInteger(n) && n >= 1 && n <= AMRAP_FLOOR_SHOWN_MAX
    ? String(n)
    : null;
};
